import { FC, useState } from 'react'

import { usePermissions } from '@/api/models/auth/hooks/usePermissions'
import { YandexMetrikaEvent } from '@/app/constants/metrics'
import { cn } from '@/app/utils'
import {
  SetUserProfileRoute,
  UserProfileRoute
} from '@/components/entities/user/hooks/useUserProfileRoute'
import { TabsRounded } from '@/components/shared/tabs'
import { useYandexMetrika } from '@/components/shared/yandex-metrika/hooks/useYandexMetrika'

import { UserProfileScreens } from '../../../lib/types'
import { AccessesTab } from '../lib/constants'
import UserContactsScreen from './UserContactsScreen'
import { UserPermissionsScreen } from './UserPermissionsScreen'

type Props = {
  setUserProfileRoute: SetUserProfileRoute
  userProfileRoute: UserProfileRoute | null
}

const ACCESS_TABS = [
  {
    key: AccessesTab.Accesses,
    title: 'Мои доступы'
  },
  {
    key: AccessesTab.Contacts,
    title: 'Контакты'
  }
]

const UserContactsDividingScreen: FC<Props> = ({
  setUserProfileRoute,
  userProfileRoute
}) => {
  const { reachGoal } = useYandexMetrika()
  const [selectedTab, setSelectedTab] = useState(
    userProfileRoute?.screen === UserProfileScreens.Contacts
      ? ACCESS_TABS[1]
      : ACCESS_TABS[0]
  )
  const permissions = usePermissions()

  const shouldShowTabs = permissions.contactsRead

  const handleSelectedTabChange = (index: number) => {
    setSelectedTab(ACCESS_TABS[index])
    if (ACCESS_TABS[index].key === AccessesTab.Contacts) {
      setUserProfileRoute(UserProfileScreens.Contacts)
      reachGoal(YandexMetrikaEvent.MAIN_CONTACTS)
      return
    }
    setUserProfileRoute(UserProfileScreens.Accesses)
  }

  return (
    <div
      className={cn(
        selectedTab.key === ACCESS_TABS[1].key &&
          permissions.contactsWrite &&
          'mb-[120px]',
        'overflow-y-auto px-40 pb-40 lg:px-24 lg:pb-24 sm:px-16 sm:pb-20'
      )}
    >
      {shouldShowTabs && (
        <TabsRounded
          noPanels
          options={ACCESS_TABS}
          selectedIndex={ACCESS_TABS.findIndex(
            tab => tab.key === selectedTab.key
          )}
          onChange={handleSelectedTabChange}
        />
      )}
      {selectedTab.key === ACCESS_TABS[0].key ? (
        <UserPermissionsScreen />
      ) : (
        <UserContactsScreen setUserProfileRoute={setUserProfileRoute} />
      )}
    </div>
  )
}

export default UserContactsDividingScreen
